<template>
<div class="main-container">
    <div class="inner-container">
        <div>
            <signed-in-user-info :user="user" :userData="userData" :loadingUser="loadingUser"/>
            <button class="update-user-button" @click="showClosedTripSheet = !showClosedTripSheet">Show <span v-show="!showClosedTripSheet">Closed</span> <span v-show="showClosedTripSheet">Open</span> Trip Sheets</button> 
            <!-- <button class="update-user-button" @click="showMasterWaypointMap = !showMasterWaypointMap"><span v-show="showMasterWaypointMap">Close</span> <span v-show="!showMasterWaypointMap">Open</span> Master Map</button>  -->
            <router-link class="update-user-button" style="text-decoration: none; font-size: 13.5px" to="/TripSheetErrorDashboard">Trip Sheet Error Dashboard</router-link>
        </div>
        
        <div v-if="(AdminUser || InternalAdmin) && !showClosedTripSheet" class="track-shipment update-user">
            <open-trip-sheet-table @selectTripSheetID="selectTripSheetID($event)" :key="refreshKey" :jwtToken="jwtToken" :userData="userData" :user="user"/>
        </div>
        <div v-if="(AdminUser || InternalAdmin) && showClosedTripSheet" class="track-shipment update-user">
            <closed-trip-sheet-table @selectTripSheetID="selectTripSheetID($event)" :key="refreshKey" :jwtToken="jwtToken" :userData="userData" :user="user"/>
        </div>
        <!-- Review Cost: shown for a selected trip sheet whose costStatus is "open", so an
             operator can review/approve its vendor cost without leaving the TripSheetDashboard.
             Opens the same TripCostEditor popup used on the TripCostDashboard. -->
        <div v-if="(BillingAdmin || AdminUser) && selectedTripSheetID && selectedTripCostStatus === 'open'" class="trip-cost-review-bar">
            <button class="review-cost-button" @click="showTripCostEditor = true">Review Cost</button>
        </div>

        <div class="trip-waypoint-map-container" v-if="selectedTripSheetID">
            <trip-waypoint-map :selectedTripSheetID="selectedTripSheetID" :userData="userData" :cognitoUser="user"/>
        </div>

        <!-- Per-trip cost editor popup (same component as the TripCostDashboard). The editor
             loads all of its own data from tripSheetId and enforces its own BillingAdmin gating. -->
        <trip-cost-editor
            v-if="showTripCostEditor && selectedTripSheetID"
            :key="selectedTripSheetID"
            :tripSheetId="selectedTripSheetID"
            :jwtToken="jwtToken"
            @closeTripCostEditor="closeTripCostEditor($event)"
        />


        <div v-if="(AdminUser || InternalAdmin) && showMasterWaypointMap" class="trip-waypoint-map-container">
            <trip-waypoint-map-master :userData="userData" :cognitoUser="user"/>
        </div>


    </div>
</div>
<AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {createGeoServiceNetwork} from '../../../graphql/mutations'
import {Auth, API} from 'aws-amplify'
import SignedInUserInfo from '../UserDashboard/SignedInUserInfo.vue'
import AlertUser from '../../../components/Popups/AlertUser.vue';
import OpenTripSheetTable from './OpenTripSheetTable.vue'
import TripWaypointMap from '../../AWSLocation/TripWaypointMap.vue';
import ClosedTripSheetTable from './ClosedTripSheetTable.vue'
import TripWaypointMapMaster from '../../AWSLocation/TripWaypointMapMaster.vue';
import TripCostEditor from '../TripCostDashboard/TripCostEditor.vue';

export default {
    data(){
        return{
            user: {},
            serviceNetworkData: {},
            jwtToken: null,
            loadingUser: false,
            userData: {},
            validateCustomAddress: false,
            userCustomAddress: "",
            toggleAlertBox: false,
            AdminUser: false,
            InternalAdmin: false,
            BillingAdmin: false,
            CreateNewAccount: false,
            Customer: false,
            CustomerAdmin: false,
            ManagePrices: false,
            EditorGroup: false,
            routeInput: {
                routeCode: "",
                serviceNetwork: "",
                geoCode: ""
            },
            refreshKey: 0,
            ManageRoutes: false,
            selectedTripSheetID: "",
            selectedTripCostStatus: null,
            showTripCostEditor: false,
            showClosedTripSheet: false,
            showMasterWaypointMap: false
        }
    },
    components:{
        AlertUser,
        OpenTripSheetTable,
        SignedInUserInfo,
        TripWaypointMap,
        ClosedTripSheetTable,
        TripWaypointMapMaster,
        TripCostEditor
    },
    mounted(){
        Auth.currentAuthenticatedUser().then(user => {
            this.user = user;
            this.jwtToken = user.signInUserSession.accessToken.jwtToken;
            this.GetUserGraphQL();
            this.listServiceNetworks();

            if(this.user.signInUserSession.idToken.payload['cognito:groups']){
                this.user.signInUserSession.idToken.payload['cognito:groups'].forEach((group)=>{
                    if(group == 'Admin'){
                      this.AdminUser = true;
                    }

                    if(group == 'InternalAdmin'){
                        this.InternalAdmin = true;
                    }

                    if(group == 'BillingAdmin'){
                        this.BillingAdmin = true;
                    }

                    if(group == 'Customer'){
                        this.Customer = true;
                    }

                    if(group == 'CustomerAdmin'){
                        this.CustomerAdmin = true;
                    }

                    if(group == 'ManagePrices'){
                        this.ManagePrices = true;
                    }

                    if(group == 'EditorGroup'){
                        this.EditorGroup = true;
                    }

                    if(group == 'ManageRoutes'){
                        this.ManageRoutes = true;
                    }
                })
                if (!this.AdminUser && !this.InternalAdmin) {
                    alert("Access denied to trip sheet dashboard")
                    // Redirect to the shipment page
                    this.$router.push('/ShipmentDashboard');
                }
            }
        }).catch(error => {
          if(error){
            this.$router.push('Login');
            Auth.signOut({global: false})
          }
        });

        const params = new URLSearchParams(window.location.search);
        const tripSheetId = params.get('tripsheetid');
        if (tripSheetId) {
            console.log('tripSheetId:', tripSheetId);
            this.selectedTripSheetID = tripSheetId;
            this.getTripCostStatus(tripSheetId);
        }
    },
    methods:{
        async selectTripSheetID(event){
            console.log(event)
            this.selectedTripSheetID = "";
            this.selectedTripSheetID = event.selectedTripSheetID;
            // Reset the cost-review state and load the selected trip's costStatus so the
            // "Review Cost" button only shows for open-cost trips.
            this.showTripCostEditor = false;
            this.selectedTripCostStatus = null;
            this.getTripCostStatus(this.selectedTripSheetID);
        },
        // Load just the costStatus for the selected trip sheet. Used to decide whether to show
        // the "Review Cost" button (open-cost trips only). Inline query omits createdAt/updatedAt
        // to avoid AWSDateTime null issues (established codebase pattern).
        async getTripCostStatus(tripSheetId){
            if (tripSheetId === null || tripSheetId === undefined || tripSheetId === "") return;
            const id = Number(tripSheetId);
            if (!Number.isFinite(id)) return;
            try {
                const resp = await API.graphql({
                    query: `query GetTripSheetCostStatus($TripSheetId: Int!){
                        getTripSheet(TripSheetId: $TripSheetId){
                            TripSheetId
                            costStatus
                        }
                    }`,
                    variables: { TripSheetId: id },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });
                this.selectedTripCostStatus = resp?.data?.getTripSheet?.costStatus ?? null;
            } catch (error) {
                console.log(error);
                // Non-fatal: without a costStatus the Review Cost button simply stays hidden.
                this.selectedTripCostStatus = null;
            }
        },
        // Close the cost editor popup. Re-check the costStatus so an approved/ignored/abandoned
        // trip's "Review Cost" button drops off after the editor writes a new status.
        closeTripCostEditor(){
            this.showTripCostEditor = false;
            if (this.selectedTripSheetID) {
                this.getTripCostStatus(this.selectedTripSheetID);
            }
        },
        async listServiceNetworks(){
            this.loadingUser = true;
            try {
                let listServiceNetworkData = await API.graphql({
                    query: `query listServiceNetworks{
                        listServiceNetworks{
                            items{
                                serviceNetwork
                            }
                        }
                    }`,
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.serviceNetworkData = listServiceNetworkData.data.listServiceNetworks;
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get route information"
            }finally{
                this.loadingUser = false;
            }
        },
        async createGeoServiceNetworkItem(){
            this.loadingUser = true;
            await this.createGeoServiceNetwork();
            this.loadingUser = false;
        },
        async GetUserGraphQL(){
            this.loadingUser = true;
            try {
                let userReturnData = await API.graphql({
                    query: `query GetUser($userName: String!){
                        getUser(userName: $userName){
                        userName
                        accountNo
                        fullname
                        locationID
                        userEmail
                        locationAddress{
                        labelImage
                        serviceAddress{
                            address{
                                companyName
                                attention
                                address1
                                address2
                                city
                                state
                                zipCode
                                phone
                                phoneExt
                                relevance
                                latitude
                                longitude
                                }
                        }
                        }
                        labelImage
                    }
                    }`,
                    variables: {
                            userName: this.user.username
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.userData = userReturnData.data.getUser;
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get user information"
            }finally{
                this.loadingUser = false;
            }
        },
        async createGeoServiceNetwork(){
            this.loadingUser = true;

            try {
                await API.graphql({
                    query: createGeoServiceNetwork,
                    variables: {
                        input: this.routeInput
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.refreshKey++
                this.toggleAlertBox = true;
                this.alertMessage = "Created Route"
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to create route."
                this.loadingUser = false;
            }
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        }
    }
}
</script>

<style scoped>
.st0{fill:none;stroke:#000000;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;}

.cls-1 {
    fill: none;
    stroke: #3f3f3f;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 10px;
}

.cls-2 {
    fill: none;
    stroke: #000;
    stroke-miterlimit: 10;
    stroke-width: 8px;
}

.cls-2-alt{
    stroke: #000;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 11px;
}

input, select{
    padding: 10px;
    font-size: 15px;
    border: 1px solid rgba(0,0,0,.336);
    border-radius: 15px;
    outline: none;
    margin-top: 5px;
}


input[type=file]::file-selector-button {
    border: none;
    padding: 5px;
    border-radius: 15px;
    background-color: #32ccfe;
    transition: 1s;
    color: #fff;
    cursor: pointer;
}

input[type=file]::file-selector-button:hover {
    background-color: #2dbbeb;
    transition: 1s;
}

.confirmLabelContainer img{
    width: 50%;
    max-width: 150px;
    margin-top: 5px;
    border-radius: 5px;
}

.trip-waypoint-map-container{
    width: 100%;
}

.trip-cost-review-bar{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding: 0 10px;
    box-sizing: border-box;
}

.review-cost-button{
    background-color: #32ccfe;
    border: 1px solid #2baeda;
    color: #fff;
    border-radius: 999px;
    padding: 8px 18px;
    cursor: pointer;
    transition-duration: .5s;
}

.review-cost-button:hover{
    filter: brightness(0.9);
    transition-duration: .5s;
}

.file-input{
    width: 80%;
}

html{
    background-color: #f3f3f3;
}

.main-container{
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.inner-container{
    width: 70%;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    border-radius: 25px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
}

.service-input-container{
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    border-radius: 25px;
    padding: 10px;
    margin-top: 5px;
    flex-basis: 30%;
}

.service-levels-inner{
    display: flex;
    flex-direction: column;
    flex-basis: 30%;
}

.confirmContainerInner1{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    flex-wrap: wrap;
}

.header-track-shipment{
    width: 100%;
    margin-bottom: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.header-track-inner{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    background-color: #e2e2e2;
    padding: 5px 15px;
    border-radius: 999px;
}

.header-track-inner svg{
    height: 22px;
    margin: 0;
}

.header-track-shipment p{
    font-size: 18px;
    margin: 0;
    margin-left: 10px;
}

.header-track-shipment{
    width: 100%;
    margin-bottom: 5px;
}

.track-shipment{
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    flex-basis: 25%;
    width: fit-content;
    height: fit-content;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.update-user{
    flex-basis: 60%;
}

.confirm-svg{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 999px;
    padding: 5px;
    width: fit-content;
}

.confirm-svg svg{
    width: 35px;
    height: 35px;
    padding-right: 5px;
}

.confirm-svg h2{
    margin: 0;
}

.user-info{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-align: left;
}

.user-info p{
    margin: 0;
}

.confirmContainerInner{
    /* display: flex; */
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
    padding: 10px;
}

.service-levels{
    display: flex;
    flex-direction: column;
    flex-basis: 30%;
}

.auto-complete-container{
    margin-top: 5px !important;
    width: 90%;
    margin-left: 10px;
}

.update-user-button{
    background-color: #e4e4e4;
    color: #000;
    border: none;
    border-radius: 999px;
    padding: 5px 15px;
    width: fit-content;
    margin-top: 5px;
    margin-left: 10px;
    margin-bottom: 5px;
    transition-duration: .5s;
    cursor: pointer;
}

.update-user-button:hover{
    transition-duration: .5s;
    background-color: #d5d5d5;
}

.add-service-button{
    margin: 0;
    margin-top: 5px;
}

@media only screen and (max-width: 1300px) {
    .inner-container{
        width: 85%;
    }
}

@media only screen and (max-width: 1000px) {
    .data-container-main, .inner-track-shipment-container{
        flex-wrap: wrap;
    }

    .track-shipment{
        flex-basis: 70%;
    }

    .data-container{
        flex-basis: 40%;
    }
}

@media only screen and (max-width: 600px) {
    .inner-container{
        width: 95%;
    }

    .data-container{
        flex-basis: 80%;
    }

    .track-shipment{
        flex-basis: 80%;
    }

    .confirmContainerInner{
        flex-wrap: wrap;
    }

    .notifications{
        margin-top: 5px;
    }
}
</style>